module.exports = __webpack_public_path__ + "static/img/bg20.71c878bc.png";